import { useEffect, useRef, useState } from "react";

/**
 * Reveal-on-scroll: returns a ref and `visible`, which turns true (once) when
 * the element scrolls into view. Without IntersectionObserver (old browsers,
 * tests) content is simply shown immediately.
 */
export function useReveal(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(
    () => typeof window === "undefined" || typeof window.IntersectionObserver !== "function"
  );

  useEffect(() => {
    if (visible || !ref.current) return undefined;
    const observer = new window.IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold, rootMargin: "0px 0px -40px 0px" }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [visible, threshold]);

  return { ref, visible };
}
